import { atom } from 'recoil';
import BeaconFilterItem from '../models/BeaconFilterItem';

const stateDiseases = atom({
  key: 'beacon.diseases',
  default: [] as BeaconFilterItem[],
});

export default stateDiseases;
